module.exports = __webpack_public_path__ + "static/media/new-sprite.5a0db80f.mp3";